// @flow

export function formatNumber (number: number) {
  try {
    return number.toLocaleString('no-NO').replace(/,/g, ' ')
  } catch (e) {
    try {
      return number.toLocaleString().replace(/,/g, ' ')
    } catch (e) {
      return number
    }
  }
}



// WEBPACK FOOTER //
// ./src/shared/helpers/formatNumber.js